/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Quota_Exhausted_HintInputs */



/**
* | output |
* | --- |
* | "Quota reached — only oneAI Standard (free) is available" |
*
* @param {Chat_Quota_Exhausted_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_quota_exhausted_hint = /** @type {((inputs?: Chat_Quota_Exhausted_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Quota_Exhausted_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Kontingent erreicht — nur oneAI Standard (kostenlos) ist verfügbar")
	return /** @type {LocalizedString} */ ("Quota reached — only oneAI Standard (free) is available")
});